// extracted by css-extract-rspack-plugin
export default {"cls1":"Home-cls1_M6n","cls2":"Home-cls2_x6I Home-cls1_M6n"};